module.exports = __webpack_public_path__ + "img/bg-whatsapp.ad169d03.jpg";